export const getTranslationText = (s: string | undefined | null, t: (s: string) => string) => {
    if(!s || s.indexOf('.') === -1 || s.indexOf(' ') > -1) return s;

    return t(s);
}
